<div class="not-found-container">
    <div class="not-found-content">
        <h1>404</h1>
        <h2>Oops! Page Not Found</h2>
        <p>The page you're looking for seems to have wandered off...</p>
        <a *ngIf="canGoBack()" (click)="goBack()" class="home-button">Go Back</a>
    </div>
</div>